<!-- 上传工具 -->
<template>
  <div class="ib">
    <el-upload
      :action="action"
      :on-success="uploadCallback"
      name="file" ref="upload"
      :limit="limit"
      :headers="headers"
      :data="data"
      :accept="accept"
      :on-progress="progress"
      :before-upload="beforeUpload"
      :multiple="limit>1"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :show-file-list="showUploading"
      :file-list="fileShowList"
      :on-exceed="handleExceed"
    >
      <!-- 0 文件 1 图片 2 视频 3音频 -->
      <slot v-if="$slots.default"></slot>
      <template v-else-if="type==0 || limit>1">
        <el-button size="mini">{{btn}}</el-button>
      </template>
      <template v-else-if="type==1">
        <img @error="errorCover" v-if="modelValue" class="obfit" :src="filePath+modelValue"  :style="'width:'+width+'px;height:'+height+'px'">
        <i v-else="" :class="'el-icon-plus '" :style="'width:'+width+'px'+';height:'+height+'px'"></i>
      </template>
      <template v-else-if="type==2">
        <video v-if="modelValue" :src="filePath+modelValue" :style="'width:'+width+'px;height:'+height+'px'" controls="controls">
          您的浏览器不支持视频播放
        </video>
        <i v-else="" :class="'el-icon-plus '" :style="'width:'+width+'px;height:'+height+'px'"></i>
      </template>
      <template v-else-if="type==3">
        <voice v-if="modelValue" :src="filePath+modelValue" :style="'width:'+width+'px;height:'+height+'px'"></voice>
        <i v-else="" :class="'el-icon-plus '" :style="'width:'+width+'px;height:'+height+'px'"></i>
      </template>
    </el-upload>
    <el-progress v-if="uploading&&showUploading" class="mt15 w200" :percentage="progressP"></el-progress>
  </div>

</template>

<script>
  import Voice from './voice'
  export default {
    components: {Voice},
    props: {
      //上传模式 默认0 后台 1七牛 2接口
      mode: {
        type: Number,
        default: 0
      },
      //mode=2,接口上传，接口地址
      url:{
        type:String,
      },
      //上传类型 默认 0 文件 1 图片 2 视频 3音频
      type: {
        type: Number,
        default: 0
      },
      //上传数量 默认1
      limit: {
        type: Number,
        default: 1
      },
      //宽度 type = 1时生效
      width: {
        type: Number,
        default: 150,
      },
      //高度 type = 1时生效
      height: {
        type: Number,
        default: 150
      },
      //上传文件控制
      accepts:{
        type:String,
        default:"",
      },
      fileList:{
        type:Array,
        default:[]
      },
      modelValue:{
        type:String,
        default:"",
      },
      isClearList:{
        type:Boolean,
        default:false
      },
      uploadData:{
        type:Object,
        default:{},
      },
      showUploading:{
        type:Boolean,
        default:false,
      },
      btn:{
        type:String,
        default:"点击上传"
      }
    },
    watch: {
      mode (n) {
        this.init()
      },
      fileList(){
        this.fileShowList = this.fileList;
      }
    },
    name: 'upload',
    data () {
      return {
        action: '',
        headers: {},
        data: {
          key: "", //图片名字处理
          token: "" ,//七牛云token
          data:{}
        },
        accept:"",
        progressP:0,
        uploading:false,
        fileShowList:[]

      }
    },
    mixins: [tableBase],
    methods: {
      //初始化
      init () {
        this.data = this.uploadData;
        if (this.mode == 0) {
          //后台上传
          this.action = baseURL + '/api/mgr/upload/uploadFile';
          this.headers = {'token': localStorage.getItem("qc_token")};
        }else if(this.mode ==1){
          //七牛上传
          this.action = 'https://up-z2.qiniup.com';
          this.headers = {};
        }else if(this.mode ==2){
          //接口上传
          this.action = baseURL + this.url;
          this.headers = {'token': localStorage.getItem("qc_token")};
        }
        if(this.accepts){
          this.accept = this.accepts;
        }else{
          //文件
          if(this.type==0){
            this.accept = "";
          }else if(this.type==1){
            //图片
            this.accept = ".jpg,.png,jpeg,png,bmp,gif,tif";
          }else if(this.type==2){
            //视频
            this.accept = ".rm,.rmvb,.vob,.flv,.mkv,.ogg,.mp4,.m4v,.mov,.3gp,.asf,.wmv,.avi,.webm";
          }else if(this.type==3){
            //音频
            this.accept = ".MP3,.WAV,.WMA,.MID,.AAC,.OGA,.APE,.FLAC,.MPC,.M4A";
          }
        }
        this.progressP = 0;
        this.fileShowList = this.fileList;
      },
      progress(){
        if(event.percent===100){
          this.progressP = 99;
        }else{
          this.progressP = parseInt(event.percent);
        }
      },
      uploadCallback(response,file, fileList){
        this.changeFileList(file,fileList)
      },
      changeFileList(file,fileList){
        if(this.limit>1){
          //批量

        }else{
          const response = file.response;
          let url;
          if(this.mode==0){
            url =response.data.url;
          }else if(this.mode==1){
            url = response.key;
          }else if(this.mode==2){
            url = response;
          }
          this.$emit("update:modelValue", url,file.name);

        }
        this.$emit("changeFile", fileList.filter(item=>{
          return item.status==='success';
        }));
        this.clearFiles();
        this.progressP = 100;
        this.uploading = false;
      },
      beforeUpload(file){
        //后台
        var fileName = file.name;
        var fileExt = fileName.substr(fileName.lastIndexOf("."), fileName.length - 1);
        if(this.accept){
          let splits = this.accept.toUpperCase().split(",");
          if (splits.indexOf(fileExt.toUpperCase()) >= 0) {
            this.uploading = true;
            if(this.mode===1){
              this.data.key = uuid().replaceAll("-","")+fileExt;
              this.data.token = this.getQiNiuToken();
            }
            return true;
          }else{
            this.$message({type: 'error', message: '上传文件格式不符合'});
            return false;
          }
        }else{
          if(this.mode===1){
            this.data.key = uuid().replaceAll("-","")+fileExt;
            this.data.token = this.getQiNiuToken();
          }
          return true;
        }
      },
      handleExceed(files, fileList) {
        if(this.limit===1){
          this.$refs.upload.clearFiles();
          const file = files[0];
          this.$refs.upload.handleStart(file);
          this.$refs.upload.submit();
        }else{
          this.$message.warning(`当前限制选择${this.limit}个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        }
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`).then((resp) =>{
          return true;
        });
      },
      handleRemove(file, fileList){
        if(this.limit>1){
          this.changeFileList(file,fileList)
        }else{
          this.$emit("update:modelValue", '');
        }

      },
      clearFiles(){
        if (this.isClearList) {
          this.$refs.upload.clearFiles();
        }
      },
      doClearFiles(){
        this.$refs.upload.clearFiles();
      }
    },
    mounted () {
      this.init()
    },
    unmounted() {

    }
  }
</script>

<style lang="less" scoped>
  .el-icon-plus{
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f2f2f2;
  }
  .obfit{
    object-fit: cover;
  }
</style>
